import * as PIXI from "pixi.js";
import gsap from "gsap";
import { GameAssets } from "src/shared/util/GameAssets";
import { GameEngine } from "../server/GameEngine";
import { soundManager } from "src/shared/UI/SoundManager";

export class BonusWin extends PIXI.Container {
    private gladiator: PIXI.Sprite;
    private fsText: PIXI.Text;
    private winLabel: PIXI.BitmapText;

    private totalWinEvent: CustomEvent = new CustomEvent("TOTAL_WIN");
    private bonusEndEvent: CustomEvent = new CustomEvent("BONUS_END");

    constructor() {
        super();
        this.gladiator = new PIXI.Sprite(
            GameAssets.textures.gameAtlas.textures["totalWinGannicus.png"],
        );
        this.gladiator.anchor.set(0.5);
        this.gladiator.position.set(0, 60);
        this.gladiator.visible = false;
        this.fsText = new PIXI.Text({
            text: `Congratulations\nYou won:`,
            style: {
                fontSize: 50,
                align: "center",
                fontFamily: "TextFont",
                fill: "0xfad035",
                stroke: { color: "0x4a1850", width: 4, join: "round" },
            },
        });

        this.winLabel = new PIXI.BitmapText({
            text: "123456.00",
            style: {
                fontSize: 25,
                fontFamily: "winFont",
                fill: "0xffffff",
            },
        });
        this.winLabel.position.set(0, 130);
        this.winLabel.anchor.set(0.5);

        this.fsText.anchor.set(0.5);
        this.fsText.position.set(0, -150);
        this.fsText.visible = false;

        this.addChild(this.gladiator);
        this.addChild(this.fsText);
        this.addChild(this.winLabel);

        this.visible = false;
    }

    async show(winning: number) {
        return new Promise<void>((resolve) => {
            this.winLabel.text = GameEngine.getInstance()
                .getFormatter()
                .format(winning);
            this.visible = true;

            this.fsText.alpha = 0;
            this.fsText.visible = true;

            this.winLabel.alpha = 0;
            this.winLabel.visible = true;

            this.gladiator.visible = true;
            this.gladiator.alpha = 0;

            document.dispatchEvent(this.totalWinEvent);

            gsap
                .timeline()
                .to(this.gladiator, {
                    delay: 2, duration: 2, alpha: 1, onComplete: () => {
                    }
                })
                .to(this.fsText, {
                    duration: 0.5,
                    alpha: 1,
                })
                .to(this.winLabel, {
                    duration: 0.5,
                    alpha: 1,
                    onComplete: () => {
                        resolve();
                    },
                });
        });
    }

    async hide() {
        return new Promise<void>((resolve) => {
            gsap.to(this.fsText, {
                duration: 1,
                alpha: 0,
            });
            gsap.to(this.winLabel, {
                duration: 1,
                alpha: 0,
            });
            gsap.to(this.gladiator, {
                alpha: 0,
                onComplete: () => {
                    this.gladiator.visible = false;
                    this.visible = false;
                    resolve();
                },
                duration: 1,
            });
            document.dispatchEvent(this.bonusEndEvent);
        });
    }
}
